import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

const RevenueByCrewChart = ({ data, currency = "AED" }) => {
  if (!data?.length) return <div style={{ padding: "32px", textAlign: "center", color: "#9CA3AF", fontSize: "14px" }}>No data available</div>;

  const fmtK = v => `${currency} ${(v / 1000).toFixed(1)}k`;

  return (
    <ResponsiveContainer width="100%" height={Math.max(200, data.length * 52)}>
      <BarChart layout="vertical" data={data} barGap={4} barSize={14} margin={{ left: 8 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" horizontal={false} />
        <XAxis type="number" tickFormatter={fmtK} tick={{ fill: "#6B7280", fontSize: 11 }} axisLine={false} tickLine={false} />
        <YAxis dataKey="crew_name" type="category" width={110} tick={{ fill: "#374151", fontSize: 12 }} axisLine={false} tickLine={false} />
        <Tooltip
          formatter={v => [`${currency} ${Number(v).toLocaleString()}`, ""]}
          contentStyle={{ background: "#fff", border: "1px solid #E5E7EB", borderRadius: "8px", fontSize: "12px" }}
        />
        <Legend wrapperStyle={{ fontSize: "12px", color: "#6B7280" }} />
        <Bar dataKey="current"  name="This Period"    fill="#2563EB" radius={[0, 4, 4, 0]} isAnimationActive animationDuration={600} />
        <Bar dataKey="previous" name="Previous Period" fill="#CBD5E1" radius={[0, 4, 4, 0]} isAnimationActive animationDuration={600} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default RevenueByCrewChart;
